// extracted by mini-css-extract-plugin
export default {"item":"ExhibitionItem_item__HVh35","link":"ExhibitionItem_link__GXa6J","image":"ExhibitionItem_image__Xs2jJ","image__wrap":"ExhibitionItem_image__wrap__SdFJe"};